function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


$('ul.brand_name li:first-child').click(function(){
  console.log('header 1')

  document.cookie = "header_brand=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
   window.location.href='/'
})

$('ul.brand_name li').click(function(){
    console.log('header 2')
    setCookie("header_brand", 'user', 30);
  var hrf=$(this).attr('href');
  window.location.href=hrf;

})

// $(document).on('click', '.secndry_hdr .site-nav__link--icon+.site-nav__link--icon', function(){

// if($(this).hasClass('is-active')){
//    $('div#MobileNav').removeClass('is-active');
//   $('div#MobileNav').addClass('is-transitioning');
//   setTimeout(function(){
    
//       $('div#MobileNav').removeClass('is-transitioning');
//   },50)
//   $(this).removeClass('is-active')
// }else{
  
//   $(this).addClass('is-active')
//   $('div#MobileNav').addClass('is-transitioning');
//   setTimeout(function(){
//     $('div#MobileNav').addClass('is-active');
//       $('div#MobileNav').removeClass('is-transitioning');
//   },50)
// }

// })
